<template>
    <div>
        <!-- Data Using Api -->
        <div class="list_news_grid">
            <div class="row-grid">
                <div class="col-grid-25" v-for="(data, index) in dataArray" :key="index">
                    <div class="item_news">
                        <div class="box-cards">
                            <a class="card-image" :href="data.detail_url_web" @click="gtmTrackerGalleryClick(data, index)">
                                <img class="background" :src="data.thumbnail"
                                    @error="data.thumbnail = base_url+'/images/default.jpg'" />
                            </a>
                        </div>
                        <div class="wrap-card-text">
                            <div class="card-content">
                                <div>
                                    <div class="card-label-sharing flex">
                                        <div class="wrap-label flex flex-center">
                                            <span><img :src="base_url+'/images/icon_calendar.png'"
                                                    alt="calendar" /></span>
                                            <p class="tx-grey date-post">
                                                {{ data.date }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="tx-black card-title">
                                        <a :href="data.detail_url_web" @click="gtmTrackerGalleryClick(data, index)">
                                            {{ data.title }}
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row-button">
                <a @click="gtmTrackerBtn()" :href="app_url+ url" class="seeMore">See More</a>
            </div>
        </div>
    </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
export default {
    props: ["relatedData", "url"],
    components: {},

    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            mobile: false,
            currentPage: 0,
            dataArray: []
        };
    },
    created() {
        this.mobile = isMobile;
    },
    watch: {
        relatedData: function(val) {
          console.log(val?.currentPage + ' ' + this.currentPage);
            if(val?.currentPage != this.currentPage){
              this.currentPage = val.currentPage;
              this.dataArray.push(...this.relatedData.relatedData);
            }
        }
    },
    methods: {
        getRelatedData() {
          if(this.relatedData.nextPageUrl){
            this.$emit("getRelatedData");
          }
        },
        gtmTrackerBtn() {
            var data = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href,
                'list': 'Related Photo'
            }
            dataLayer.push(data);
        },
        gtmTrackerGalleryClick(data, index) {
            const track = {
                'event': 'galleryClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Gallery Click', 
                'eventDetail.label': data.title, // 'Video Click', 
                'position': index + 1
            }
            console.log(track)
            dataLayer.push(track);
        },
    }
};
</script>
<style scoped lang="scss">
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.row-grid .col-grid-25 {
    margin-bottom: 30px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    margin-top: 15px;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}

.item_news .shares {
    right: 42px;
    left: inherit;
}
.card-content {
    white-space: normal;
}
.card-desc {
    margin-bottom: 20px;
}
.card-desc p {
    color: #727272;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
}
.wrap-card-text {
    position: relative;
    padding: 5px 20px;
    background-color: transparent;
}
.card-title {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 20px;
    a {
        color: #fff;
        font-size: 20px;
        max-width: 100%;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
    }
}
.cta-card-box {
    display: flex;
}
.cta-card-box a {
    font-weight: 500;
    display: inline-block;
    padding: 5px 20px;
    font-size: 16px;
    border-radius: 10px;
    border: solid 1px #282828;
    color: #282828;
}
.cta-card-box a span {
    color: #e61b33;
}

.cta-card-box a .box-cards .cta-card-box a span {
    margin-left: 10px;
    font-size: 20px;
}
.labelActive {
    position: absolute;
    right: 20px;
    top: 20px;
}
.inner-title {
    display: flex;
    align-items: center;
}
.card-image {
    // margin-bottom: -5px;
    overflow: hidden;
    width: 100%;
    // height: 185px;
    display: block;
    img {
        width: 100%;
        // height: 185px;
        // object-fit: cover;
        // opacity: 0;
    }
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

}
.row-button {
    display: block;
    width: 100%;
    text-align: center;
}
.seeMore {
    display: inline-block;
    background: #282828;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    padding: 10px 20px;
}
@media all and (max-width: 767px) {
  .card-image {
      .background {
        //   height: 226px;
      }
  }
}
</style>
